import { PortalDsButton } from 'src/components/portal-design-system';

const WINDOW_OPTIONS = [7, 30] as const;

interface ReportingApiFilterBarProps {
  days: number;
  onDaysChange: (days: number) => void;
}

export function ReportingApiFilterBar({ days, onDaysChange }: ReportingApiFilterBarProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm font-medium text-[#4B5060]">
        Window
      </span>
      {WINDOW_OPTIONS.map((option) => (
        <PortalDsButton
          key={option}
          variant={days === option ? 'primary' : 'secondary'}
          size="sm"
          onClick={() => onDaysChange(option)}
        >
          {option}
          {' '}
          days
        </PortalDsButton>
      ))}
    </div>
  );
}
